import { useEffect, useMemo } from "react";

function branches(seed) {
  let s = seed;
  const rnd = () => ((s = (s * 9301 + 49297) % 233280) / 233280);
  const paths = [];
  const grow = (x, y, ang, len, depth, delay) => {
    let d = `M${x.toFixed(1)} ${y.toFixed(1)}`;
    let total = 0;
    for (let i = 0; i < 6; i++) {
      ang += (rnd() - 0.5) * 0.9;
      const nx = x + Math.cos(ang) * len;
      const ny = y + Math.sin(ang) * len;
      d += ` Q${(x + nx) / 2 + (rnd() - 0.5) * 30} ${(y + ny) / 2 + (rnd() - 0.5) * 30} ${nx.toFixed(1)} ${ny.toFixed(1)}`;
      total += len * 1.15;
      x = nx;
      y = ny;
      if (depth < 3 && rnd() < 0.45) grow(x, y, ang + (rnd() < 0.5 ? -1 : 1) * (0.6 + rnd()), len * 0.7, depth + 1, delay + i * 0.5);
    }
    paths.push({ d, len: Math.ceil(total), delay, w: Math.max(0.6, 2.6 - depth * 0.7) });
  };
  const starts = [[0, 120, 0.2], [0, 620, -0.3], [1920, 80, 3.2], [1920, 760, 3.4], [600, 0, 1.4], [1300, 1080, -1.6], [960, 0, 1.7], [0, 1000, -0.6]];
  starts.forEach(([x, y, a], i) => grow(x, y, a, 70 + rnd() * 40, 0, i * 0.4));
  return paths;
}

const WHISPERS = [
  ["we remember", 8, 22], ["the network remembers", 70, 14], ["she came back", 14, 70], ["occupied", 82, 62],
  ["he walks your halls", 44, 88], ["you chose wrong", 60, 40], ["we received him", 26, 46], ["open the door", 88, 86],
];

export function SporeTakeover() {
  const paths = useMemo(() => branches(1337), []);
  useEffect(() => {
    document.body.classList.add("spores-takeover");
    return () => document.body.classList.remove("spores-takeover");
  }, []);
  return (
    <div className="fixed inset-0 z-[5] pointer-events-none overflow-hidden" aria-hidden data-testid="spores-takeover-overlay">
      <svg viewBox="0 0 1920 1080" preserveAspectRatio="xMidYMid slice" className="absolute inset-0 w-full h-full">
        <g fill="none" stroke="#0ed7a8" strokeLinecap="round" opacity="0.38" style={{ filter: "drop-shadow(0 0 4px rgba(14,215,168,0.6))" }}>
          {paths.map((p, i) => (
            <path key={i} d={p.d} strokeWidth={p.w} className="myc-path" style={{ "--len": p.len, animationDelay: `${p.delay}s` }} />
          ))}
        </g>
      </svg>
      {WHISPERS.map(([t, x, y], i) => (
        <span key={t} className="whisper text-2xl" style={{ left: `${x}%`, top: `${y}%`, animationDelay: `${i * 1.3}s` }}>{t}</span>
      ))}
    </div>
  );
}
